

;(function($) {
    $(document).ready(function() {

        var regVerifyForm = $("#domain-registrant-verification");

        let regexName = /^[a-zA-Z\s]+$/;
        let regexCity = /^[a-zA-Z\s]+$/;
        let regexStreet = /^[A-Za-z0-9 .,-]+$/;
        let regexOrgName = /^[a-zA-Z0-9.&\-"' ]+$/;

        // zip / org number rules depend on the owner's country (window.isValidZipForCountry in validate-utils.js)
        let ownerCountry = regVerifyForm.data('country');
        let regexZip = {
            test: function(value) {
                // the stored zip is read-only and checked only when changed (as on the server)
                return $('#address_zip').prop('readonly') || window.isValidZipForCountry(value, ownerCountry);
            }
        };
        let regexOrgID = {
            test: function(value) {
                return window.isValidCompanyIdForCountry(value, ownerCountry);
            }
        };

        function validateInput(input, regex) {
            let value = $(input).val();
            if (!regex.test(value)) {
                $(input).addClass("input-error");
                return false;
            } else {
                $(input).removeClass("input-error");
                return true;
            }
        }

        //name
        regVerifyForm.find('input[name="name"]').on("input", function () {

            let value = $(this).val();
            if (!regexName.test(value)) {
                $(this).val(value.replace(/[^a-zA-Z\s]/g, '').substring(0, 150));
            }
            validateInput(this, regexName);
        });

        //city
        regVerifyForm.find('input[name="address_city"]').on("input", function () {

            let value = $(this).val();
            if (!regexCity.test(value)) {
                $(this).val(value.replace(/[^a-zA-Z\s]/g, '').substring(0, 150));
            }
            validateInput(this, regexCity);
        });

        //street
        regVerifyForm.find('input[name="address_street"]').on("input", function () {

            let value = $(this).val();
            if (!regexStreet.test(value)) {
                $(this).val(value.replace(/[^A-Za-z0-9 .,-]/g, '').substring(0, 150));
            }
            validateInput(this, regexStreet);
        });

        //zip
        regVerifyForm.find('input[name="address_zip"]').on("input", function () {
            validateInput(this, regexZip);
        });

        //organization_number
        regVerifyForm.find('input[name="organization_number"]').on("input", function () {

            let value = $(this).val();

            if (window.isIsraelCountry(ownerCountry) && !regexOrgID.test(value)) {
                $(this).val(value.replace(/\D/g, '').replace(/^(\d{1})/, '5').substring(0, 9));
            }
            validateInput(this, regexOrgID);
        });

        //organization_name
        regVerifyForm.find('input[name="organization_name"]').on("input", function () {

            let value = $(this).val();

            validateInput(this, regexOrgName);
        });

        //phone
        regVerifyForm.find('input[name="phone_number"]').on("input", function () {

            let value = $(this).val();

            value.replace(/\D/g, '');

            if (!isValidIsraeliPhone(value)) {
                $(this).addClass("input-error");
                $(this).val(value.replace(/\D/g, '').substring(0, 10));
            } else {
                $(this).removeClass("input-error");
            }
        });


        regVerifyForm.find(":input").on("invalid", function() {
            this.setCustomValidity(translations['this input is required field'] || key);
        }).on("input", function() {
            this.setCustomValidity(""); 
        });

        regVerifyForm.on("submit", function (e) {

            let valid = true;

            $("#domain-registrant-verification-errors").empty();

            if ($("#name").length) {
                valid &= validateInput("#name", regexName) ? true : (addErrorMessage("Name Is Invalid"), false);
            }
            valid &= validateInput("#address_city", regexCity) ? true : (addErrorMessage("City Is Invalid"), false);
            valid &= validateInput("#address_street", regexStreet) ? true : (addErrorMessage("Address Is Invalid"), false);
            valid &= validateInput("#address_zip", regexZip) ? true : (addErrorMessage("Zip is invalid"), false);
            if ($("#organization_number").length) {
                valid &= validateInput("#organization_number", regexOrgID) ? true : (addErrorMessage("Org ID Is Invalid"), false);
            }
            if ($("#organization_name").length) {
                valid &= validateInput("#organization_name", regexOrgName) ? true : (addErrorMessage("Org Name Is Invalid"), false);
            }
            valid &= isValidIsraeliPhone($("#phone_number").val()) ? true : (addErrorMessage("Phone Number Is Invalid"), false);
            valid &= validateVerificationForm()? true : (addErrorMessage("Please select at least one file for verification documents"), false);
            

            if (!valid) {
                e.preventDefault();
            }

        });

        function addErrorMessage(key) {
            errMsgDiv = $('#domain-registrant-verification-errors');
            var message = translations[key] || key;
            errMsgDiv.append('<p>' + message + '</p>');
        }

        function isValidIsraeliPhone(phone) {

			if (phone.length !== 9 && phone.length !== 10) {
                $('#phone_number').addClass("input-error");
                return false;
            } 

			var regex = /^((\+972|0)([2-9])[0-9]{7}|(\+972|0)(2|3|4|7|8|9)[0-9]{7}|(\+972|0)5[0-9]{8}|(\+972|0)7[0-9]{8})$/;
			if (phone.startsWith('07') && phone.length !== 10) {
                $('#phone_number').addClass("input-error");
				return false;
			}
			if (phone.startsWith('05') && phone.length !== 10) {
                $('#phone_number').addClass("input-error");
				return false;
			}
            $('#phone_number').removeClass("input-error");
			return regex.test(phone);
		}

        let maxIdentityFiles = 5;
        let currentVisible = 1;

        $('#addButton').click(function() {
            if (currentVisible < maxIdentityFiles) {
                currentVisible++;
                $('#identity' + currentVisible).show();
            }
        });

        $('#removeButton').click(function() {
            if (currentVisible > 1) {
                $('#identity' + currentVisible).hide().val('');
                currentVisible--;
            }
        });
        

    });
})(jQuery);


// document.addEventListener('DOMContentLoaded', () => {
//     const addButton = document.getElementById('addButton');
//     const removeButton = document.getElementById('removeButton');
//     const maxInputs = 5; // Total number of inputs
//     let visibleInputs = 1; // Start with only one input visible

//     // Add button functionality
//     addButton.addEventListener('click', () => {
//         if (visibleInputs < maxInputs) {
//             visibleInputs++;
//             const nextInput = document.getElementById(`identity${visibleInputs}`);
//             if (nextInput) {
//                 nextInput.style.display = 'block';
//             }
//         }
//     });

//     // Remove button functionality
//     removeButton.addEventListener('click', () => {
//         if (visibleInputs > 1) {
//             const currentInput = document.getElementById(`identity${visibleInputs}`);
//             if (currentInput) {
//                 currentInput.value = ''; // Clear the value
//                 currentInput.style.display = 'none';
//             }
//             visibleInputs--;
//         }
//     });
// });